// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2HHbQ","log":"ModalInventoryLogs_log__3QerT","date":"ModalInventoryLogs_date__2c5_d","userName":"ModalInventoryLogs_userName__1Uq9F"};